import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export class DeleteRmaLine extends RmaRequest<void, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit = { method: 'DELETE' }

  constructor({ lineId }: { lineId: string }) {
    super()
    this.path = `account/rma/draft/delete/line/${lineId}/`
  }
}
